import React from 'react';
import { numberFormat } from '@airasia-common/libraries/i18n/LocaleHelper';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import Wrapper from './Wrapper';
import Card from './Card/Card';
import hotelCardPropTypes from './HotelCard/HotelCard.propTypes';
import PriceText from './Text/PriceText';

const HotelRoomPrice = ({ props }) => {
  const {
    baseRate,
    strikethroughPrice,
    guestCount,
    guestHintText,
    priceHintText,
    enableTotalGuestPrice,
    perPersonBaseRate,
    perPersonStrikethroughPrice,
    isSnap,
    roundBaseValue,
    roundStrikethroughPrice,
    roundPerPersonBaseValue,
    roundPerPersonStrikethroughPrice,
    hideInfo,
  } = props;

  return (
    <>
      {!isSnap ? (
        <Wrapper>
          {roundStrikethroughPrice ? (
            <Wrapper>
              <PriceText
                className="discount"
                variant="strikeThrough"
                currency={strikethroughPrice.currency || baseRate.currency}
              >
                {roundStrikethroughPrice}
              </PriceText>
            </Wrapper>
          ) : null}

          <PriceText
            className="price"
            variant="price"
            marginTop={roundStrikethroughPrice ? 0 : 4}
            currency={baseRate.currency}
          >
            {roundBaseValue}
          </PriceText>

          {enableTotalGuestPrice ? (
            <Card.HintText
              className="guest-hint"
              color={'darkBlack'}
              fontWeight="500"
            >
              {`${translate('hotelCard.snapGuestText', {
                smart_count: guestCount,
                guests: numberFormat(guestCount),
              })}`}
            </Card.HintText>
          ) : (
            guestHintText && (
              <Card.HintText
                className="guest-hint"
                color={'darkBlack'}
                fontWeight="500"
              >
                {guestHintText}
              </Card.HintText>
            )
          )}
          <Card.HintText className="price-hint">{priceHintText}</Card.HintText>
        </Wrapper>
      ) : (
        <Wrapper>
          {hideInfo ? null : roundPerPersonStrikethroughPrice ? (
            <Wrapper>
              <PriceText
                className="discount"
                variant="strikeThrough"
                currency={
                  perPersonStrikethroughPrice.currency ||
                  perPersonBaseRate.currency
                }
              >
                {roundPerPersonStrikethroughPrice}
              </PriceText>
            </Wrapper>
          ) : null}
          <PriceText
            className="price"
            variant="price"
            marginTop={perPersonStrikethroughPrice ? 0 : 4}
            currency={perPersonBaseRate.currency}
          >
            {roundPerPersonBaseValue}
          </PriceText>

          <Card.HintText
            className="guest-hint"
            color={'darkBlack'}
            fontWeight="500"
          >
            {translate('hotelCard.perGuestText')}
          </Card.HintText>
          <Card.HintText className="price-hint">{priceHintText}</Card.HintText>

          {enableTotalGuestPrice && (
            <Wrapper>
              <PriceText
                className="price"
                variant="guestTotal"
                marginTop={4}
                currency={baseRate.currency}
                displayTotal={`${translate('hotelCard.total')}`}
              >
                {roundBaseValue}
              </PriceText>
            </Wrapper>
          )}
        </Wrapper>
      )}
    </>
  );
};
HotelRoomPrice.propTypes = hotelCardPropTypes;

export default HotelRoomPrice;
